export enum BubbleType {
  Text = 'text',
  Link = 'link',
  List = 'list',
}
